export default "/fonts/vendor/primeicons/primeicons.woff2?024b32cc7bf399b1a8472b896f3395c9";